


window.addEventListener('load', () => {
  const target = document.querySelector('#round1');
  if (!target) {
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        entry.target.nextElementSibling.classList.add('is-visible');
        observer.unobserve(target);
      }
    });
  });

  observer.observe(target);
});


  
  
  $('#modalbtn').click(function () {
    $(this).toggleClass("active");
    $(".nav-box").toggleClass("active");
  });
  $('.modalclose').click(function () {
    $('#modalbtn').toggleClass("active");
    $(".nav-box").toggleClass("active");
  });
  $('.closelink').click(function () {
    $('#modalbtn').toggleClass("active");
    $(".nav-box").toggleClass("active");
  });


// ハンバーガーメニューボタンがクリックされたときのイベントハンドラを設定
  $("#modalbtn").click(function () {

    // 現在のbodyタグのoverflowスタイルを確認
    if ($("html").css("overflow") === "hidden") {

      // もしoverflowがhiddenなら、bodyのスタイルを元に戻す
      $("html").css({ height: "", overflow: "" });

    } else {

      // そうでなければ、bodyにheight: 100%とoverflow: hiddenを設定し、スクロールを無効にする
      $("html").css({ height: "100%", overflow: "hidden" });

    }
  });

  $(".closebtn").click(function () {

    // 現在のbodyタグのoverflowスタイルを確認
    if ($("html").css("overflow") === "hidden") {

      // もしoverflowがhiddenなら、bodyのスタイルを元に戻す
      $("html").css({ height: "", overflow: "" });

    } else {

      // そうでなければ、bodyにheight: 100%とoverflow: hiddenを設定し、スクロールを無効にする
      $("html").css({ height: "100%", overflow: "hidden" });

    }
  });
  
  $(".modalclose").click(function () {

    // 現在のbodyタグのoverflowスタイルを確認
    if ($("html").css("overflow") === "hidden") {

      // もしoverflowがhiddenなら、bodyのスタイルを元に戻す
      $("html").css({ height: "", overflow: "" });

    } else {

      // そうでなければ、bodyにheight: 100%とoverflow: hiddenを設定し、スクロールを無効にする
      $("html").css({ height: "100%", overflow: "hidden" });

    }
  });

  $(".closelink").click(function () {

    // 現在のbodyタグのoverflowスタイルを確認
    if ($("html").css("overflow") === "hidden") {

      // もしoverflowがhiddenなら、bodyのスタイルを元に戻す
      $("html").css({ height: "", overflow: "" });

    } else {

      // そうでなければ、bodyにheight: 100%とoverflow: hiddenを設定し、スクロールを無効にする
      $("html").css({ height: "100%", overflow: "hidden" });

    }
  });
  



 if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
    
  } else {
  }

window.addEventListener('pageshow', (e) => {
   if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
  if (e.persisted) {
    window.location.reload();
  }
   };
});


var headNav = $(".fixed-btn");
var footer = $("footer"); 

$(window).on('load scroll', function () {
    var scrollPos = $(this).scrollTop();
    var windowHeight = $(window).height();
    
    // フッターの上端位置を取得（要素がない場合はドキュメントの最下部を代入）
    var footerTop = footer.length ? footer.offset().top : $(document).height();
    
    // 画面の下端がフッターに到達したかどうかの判定
    var isFooterVisible = (scrollPos + windowHeight) >= footerTop;

    if (scrollPos > 500 && !headNav.hasClass('fixed') && !isFooterVisible) {
        // 500px以上スクロールし、かつフッターが見えていない時に表示
        headNav.css({"bottom": '-150px'}); 
        headNav.addClass('fixed');
        headNav.stop().animate({"bottom": 0}, 600);
    }
    else if (isFooterVisible && headNav.hasClass('fixed')) {
        // フッター領域に入ったらスッと隠す
        headNav.removeClass('fixed');
        headNav.stop().animate({"bottom": '-150px'}, 300);
    }
    else if (scrollPos <= 300 && headNav.hasClass('fixed')) {
        // 上部に戻った時も隠す
        headNav.removeClass('fixed');
        headNav.css({"bottom": '-150px'}); 
    }
});

// 


var headNav2 = $("#line-banner");

headNav2.each(function() {
    $(this).wrap('<div class="nav-placeholder" style="display: block;"></div>');
});

$(window).on('load scroll', function () {
    var scrollPos2 = $(this).scrollTop();
    var placeholder = headNav2.parent('.nav-placeholder');

    headNav2.each(function() {
        if (!$(this).hasClass('fixed')) {
            placeholder.height($(this).outerHeight(true));
        }
    });

    // プレースホルダーの上端位置 ＋ 要素の高さ ＝ 要素が完全に画面上に隠れるライン
    var triggerPoint = placeholder.offset().top + placeholder.outerHeight();

    if(scrollPos2 > triggerPoint && headNav2.hasClass('fixed') == false) {
        headNav2.css({"bottom": '-150px'});
        headNav2.addClass('fixed');
        headNav2.animate({"bottom": 0}, 600);
    }
    else if(scrollPos2 <= triggerPoint && headNav2.hasClass('fixed') == true){
        headNav2.removeClass('fixed');
    }
});



$('.qa-list .question').click(function () {
    $(this).toggleClass("active");
    $(this).nextAll(".answer").slideToggle();
  });



   var swiper = new Swiper(".pc-back_swiper", {
    loop: true,
  effect: 'fade',
  speed: 1500,
    freeMode: false,
      loop: true,
        autoplay: {
      delay: 2500,
    }
  });

   var swiper = new Swiper(".top-about_text-swiper", {
     centeredSlides: true,
    slidesPerView: 1.2,
    spaceBetween: 25,
    freeMode: false,
      freeModeSticky: true,
       centeredSlides: true,
       speed: 6000,
      loop: true,
       autoplay: {
      delay: 0,
      disableOnInteraction: false,
    }
  });

  var swiper = new Swiper(".product_text-swiper", {
     centeredSlides: true,
   centeredSlides: true,
    slidesPerView: 1.2,
    spaceBetween: 50,
    freeMode: false,
      freeModeSticky: true,
       centeredSlides: true,
       speed: 6000,
      loop: true,
       autoplay: {
      delay: 0,
      disableOnInteraction: false,
    }
  });


document.addEventListener('DOMContentLoaded', () => {
  // ーーー 1つ目のスライダー（サムネイル用など） ーーー
  const slider1 = document.querySelector('.thumbnail-list');
  let isDown1 = false;
  let startX1;
  let scrollLeft1;

  slider1.addEventListener('mousedown', (e) => {
    isDown1 = true;
    startX1 = e.pageX - slider1.offsetLeft;
    scrollLeft1 = slider1.scrollLeft;
    slider1.style.cursor = 'grabbing';
  });
  slider1.addEventListener('mouseleave', () => { isDown1 = false; slider1.style.cursor = 'grab'; });
  slider1.addEventListener('mouseup', () => { isDown1 = false; slider1.style.cursor = 'grab'; });
  slider1.addEventListener('mousemove', (e) => {
    if (!isDown1) return;
    e.preventDefault();
    const x = e.pageX - slider1.offsetLeft;
    const walk = (x - startX1) * 2;
    slider1.scrollLeft = scrollLeft1 - walk;
  });
});
